export const calculateUserStats = (
  userProfile,
  activityData,
  metValue = 2.7
) => {
  // --- Basic Calculations ---
  const durationInSeconds = activityData.duration;
  const durationInHours = durationInSeconds / 3600;

  // 1. Calculate Steps
  const distanceInCm = activityData.distance * 100;
  const totalSteps = distanceInCm / userProfile.step;

  // 2. Calculate Heart Rate Percentage
  const heartRatePercentage =
    (activityData.heartrate / userProfile.hrMax) * 100;

  // --- Calorie Calculations ---

  // A. Calculate Basal Metabolic Rate (BMR) for a full day using Mifflin-St Jeor
  let bmrPerDay = 0;
  if (userProfile.gender.toLowerCase() === "male") {
    bmrPerDay =
      10 * userProfile.weight +
      6.25 * userProfile.height -
      5 * userProfile.age +
      5;
  } else {
    // Assuming female
    bmrPerDay =
      10 * userProfile.weight +
      6.25 * userProfile.height -
      5 * userProfile.age -
      161;
  }
  // BMR for your profile: (10*98) + (6.25*176) - (5*54) + 5 = 1815 calories/day

  // B. Calculate resting calories burned *during the activity's duration*
  const restingCalories = (bmrPerDay / 24) * durationInHours;
  // For your activity: (1815 / 24) * 21.75 hours = 1644 calories

  // C. Calculate active calories using the METs formula
  const activeCalories = metValue * userProfile.weight * durationInHours;
  // For your activity (MET 2.9): 2.9 * 98 * 21.75 = 6178 calories

  // D. Calculate total calories
  const totalCalories = activeCalories + restingCalories;
  // For your activity: 6178 + 1644 = 7822 calories

  return {
    steps: Math.round(totalSteps),
    activeCalories: Math.round(activeCalories),
    totalCalories: Math.round(totalCalories),
    heartRatePercent: Math.round(heartRatePercentage),
  };
};

// *** calories
